import { render } from "./AddWard.vue?vue&type=template&id=4ca42f6b"
import script from "./AddWard.vue?vue&type=script&lang=js"
export * from "./AddWard.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__